import type { IconSvgObject } from './types';

const PolicyIcon: IconSvgObject = [
  ["path", { d: "M16.6106 17.6596L15.5 22L18 21L20.5 22L19.5 17.5987M21 15C21 16.6569 19.6569 18 18 18C16.3431 18 15 16.6569 15 15C15 13.3431 16.3431 12 18 12C19.6569 12 21 13.3431 21 15Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 22H5.00002C3.89544 22 3.00001 21.1046 3.00002 20L3.00016 3.99998C3.00017 2.89542 3.89559 2 5.00016 2H18C19.1046 2 20 2.89543 20 4V9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7.5 7H15.5M7.5 12H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PolicyIcon;
